import ProductAttributeFA from './fa/fa.json'

const ProductAttributeMessages = {
  fa: { ...ProductAttributeFA },
}

export default ProductAttributeMessages
